import {Component, Input} from '@angular/core';
import {DatePipe, NgClass, NgIf, NgStyle} from '@angular/common';
import {IconComponent} from '../../../../../shared/components/icons-svgs/icons-svgs.component';
import {TranslateModule} from '@ngx-translate/core';
import {ProcessService} from '../../../../../services/user-services/process.service';
import {Router} from '@angular/router';
import { LocalSettingsService } from 'src/app/services/local-settings.service';

@Component({
  selector: 'app-booking-card',
  imports: [
    DatePipe,
    IconComponent,
    NgClass,
    NgIf,
    TranslateModule,
    NgStyle
  ],
  templateUrl: './booking-card.component.html',
  standalone: true,
  styleUrl: './booking-card.component.scss'
})
export class BookingCardComponent {
  @Input() public booking;
  @Input() public style: string = '';
  currentLanguage: string;

  constructor(
    private processService: ProcessService,
    private router: Router,
    private localSettingsService: LocalSettingsService
  ) {
  }
  ngOnInit(): void {

    this.localSettingsService.language$.subscribe(
      (language: string) => {
        this.currentLanguage = language;
      }
    );
  }



  public trackById(index, item): number {
    return item.id;
  }

  public openProperty(booking): void {
    window.open(this.currentLanguage+'/accommodation/property/' + booking.property_id);
  }

  navigate(booking: any) {
    this.processService.setTempBooking(booking.start_date, booking.end_date, booking.property_id, booking.id, booking.status, booking.reduced_reservation_fees);
    if (booking.status === 'Accepted') {
      this.router.navigate([this.currentLanguage+'/accommodation/post-reservation']);
    } else if (booking.status === 'Pending') {
      this.router.navigate([this.currentLanguage+'/accommodation/pending']);
    } else if (booking.status === 'Declined') {
      const refuseReason = this.getRefuseReason(booking);
      this.router.navigate([this.currentLanguage+'/accommodation/rejected'], {queryParams: {refuseReason: refuseReason}});
    }
  }

  public cancel(booking): void {
    this.processService.setTempBooking(booking.start_date, booking.end_date, booking.property_id, booking.id, booking.status);
    this.router.navigate([this.currentLanguage+'/accommodation/call-an-agent']);

  }

  private getRefuseReason(booking) {
    switch (booking.refuse_reason) {
      case 'Séjour trop court':
        return '1';
      case 'Grand nombre de demande sur le logement':
        return '2';
      case 'Demande à risque (cautionnement)':
        return '3';
      case 'Trop tôt':
        return '4';
      case 'Indisponible':
        return '5';
      case 'Déja loué':
        return '6';
      default:
        return '';
    }
  }

}
